import { useFormContext, useWatch } from 'react-hook-form';
import { BoloPanelFormType } from '../../../../../../api-ts-packages/cad-api';
import { useDebounce } from '@cad-arc';
import { useSelectedLocation } from '../../event-panel/tabs/hooks/use-selected-location';
import { getRelatedDataQueriesForEntityPanel } from '../../panels/entity-panels/related-data/related-data-queries';

export const useBoloRelatedDataQueries = () => {
    const boloForm = useFormContext<BoloPanelFormType>();

    /**
     * We debounce our watched values because
     * we don't want to refetch on every keystroke
     */
    const [involvedPersons] = useDebounce(
        useWatch({
            name: 'involvedPersons',
            control: boloForm.control,
        }),
        400
    );

    /**
     * We debounce our watched values because
     * we don't want to refetch on every keystroke
     */
    const [vehicles] = useDebounce(
        useWatch({
            name: 'involvedVehicles',
            control: boloForm.control,
        }),
        400
    );

    const location = useSelectedLocation();

    const {
        vehicleQueries,
        personQueries,
        phoneNumbers,
        relatedDataLocationQuery,
    } = getRelatedDataQueriesForEntityPanel(
        involvedPersons,
        vehicles,
        location,
        boloForm.getValues('locationSubPremise')
    );

    return {
        vehicleQueries,
        personQueries,
        phoneNumbers,
        relatedDataLocationQuery,
    };
};
